import { FC } from 'react';

import { OnboardingWizardProvider } from '../contexts/OnboardingWizardContext';
import { OnboardingWizard } from '../components/OnboardingWizard/OnboardingWizard';


export const Onboarding: FC = () => {

  return (
    <OnboardingWizardProvider>
      <OnboardingWizard/>
    </OnboardingWizardProvider>
  );
};
